import { fromJS } from 'immutable';
import { pathSubscription } from 'nike-re-framejs';

export const profile$ = userNickname => pathSubscription(['betbook', 'profiles', userNickname]);

export const setProfile = profile => db => db.setIn(['betbook', 'profiles', profile.nickname], fromJS(profile));
